export const initialLogInData = {
    email: "",
    password: ""
}
export const initialSignUpData = {
    firstName: "",
    lastName: "",
    email: "",
    username:"",
    password: ""
}
export const guestData = {
    email: "test@gmail.com",
    password: "123456",
  };